import { Dictionaries } from './dictionary';
const pt: Dictionaries = {

  'reveal.text': 'Consulte mais informação',

  'summary.transactionAmount': 'Valor',
  'summary.transactionReceiveAmount': 'Valor do pago',
  'summary.email': 'E-mail',
  'summary.transactionDate': 'Data da transação:',
  'summary.paymentMethod': 'Método de pagamento',
  'summary.include': 'Contiene',
  'summary.identifier': 'Id buscado',


  'form.header': 'Verificar o estado do pagamento',

  'formData.amount': 'Valor da transação',
  'formData.currency': 'Moeda',
  'formData.transactionDate': 'Data da transação',
  'formData.transactionId': 'Número da transação, número do pedido ou referência',
  'formData.paymentMethod': 'Método de pagamento',
  'formData.email': 'E-mail',
  'formData.separator': '---------------------- OU ----------------------',

  'formData.button': 'Seguindo',
  'formData.tryAgainButton': 'Tente novamente',
  'formData.sendVoucherButton': 'Envie o comprovante',
  'formData.errorSendingVoucher': 'Erro ao enviar o voucher',
  'formData.completeSendVoucher': 'Voucher enviado para o e-mail cadastrado',

  'formData.validation.required': 'O campo obrigatório',
  'formData.validation.date.incorrect': 'A data deve ser dos últimos 3 meses',
  'formData.validation.gt.zero': 'O valor deve ser maior que zero',
  'formData.validation.incorrectEmail': 'Formato de e-mail incorreto',

  'transactionStatus.header': 'Status do pagamento',

  'status.AUTHORIZED': 'Autorizada',
  'status.ABANDONED': 'Abandonada',
  'status.ANTIFRAUD_REJECTED': 'Rejeição anti-fraude',
  'status.BANK_FRAUD_REJECTED': 'Rejeição bancária',
  'status.BANK_REJECTED': 'Rejeição bancária',
  'status.CANCELLED': 'Cancelada',
  'status.ERROR': 'Erro',
  'status.EXPIRED': 'Expirada',
  'status.PLATFORM_REJECTED': 'Rejeição da rede',
  'status.PAID': 'Paga',
  'status.CHARGEBACK': 'Chargeback',
  'status.PENDING': 'Pendente',
  'status.REFUND': 'Devolvida',
  'status.IN_DISPUTE': 'Em disputa',
  'status.PARTIAL_REFUND': 'Reembolso parcial',
  'status.THREEDS_REJECTED': 'Rejeição por 3ds',
  'status.RETURNING': 'Em processo de reembolso',
  'status.NOT_FOUND': 'Outro',

  'transaction-info.authorized.body':
      '<p>Sua transação foi autorizada. Para solicitar a cobrança ou a liberação do saldo, entre em contato com o comerciante.</p>',
  'transaction-info.abandoned.body':
      '<p>Por favor, tente efetuar o pagamento novamente.</p>',
  'transaction-info.antifraud-rejected.body':
      '<p>Por favor, entre em contato com nossa equipe de atendimento ao cliente, tendo em mãos as seguintes informações: a data da transação, o número da ordem e a referência da transação. Lembre-se que, no site da PayU do seu país, você encontrará a seção de suporte, por meio da qual você poderá entrar em contato com nossa equipe de Atendimento ao Cliente.</p>',
  'transaction-info.bank-fraud-rejected.body':
      '<p>Entre em contato com o seu banco e verifique o motivo pelo qual você não conseguiu fazer a compra. Depois que eles te informarem o motivo, você pode tentar fazer a compra novamente.</p>',
  'transaction-info.bank-rejected.body':
      '<p>Entre em contato com o seu banco e verifique o motivo pelo qual você não conseguiu fazer a compra. Depois que eles te informarem o motivo, você pode tentar fazer a compra novamente.</p>',
  'transaction-info.cancelled.body':
      '<p>Sua transação foi cancelada. Por favor, tente novamente.</p>',
  'transaction-info.error.body':
      '<p>Sua transação não foi aprovada. Por favor, tente novamente.</p>',
  'transaction-info.expired-card.body':
      '<p>Seu cartão está vencido. Tente outra forma de pagamento.</p>',
  'transaction-info.expired-transaction.body':
      '<p>O pedido ultrapassou o tempo limite que você tinha para efetuar o pagamento, tente novamente ou se você efetuou o pagamento e ainda continua neste status, é necessário que você nos envie o comprovante do pagamento.</p>',
  'transaction-info.platform-rejected.body':
      '<p>Sua transação foi recusada, por favor tente efetuar o pagamento novamente.</p>',
  'transaction-info.paid.body':
      '<p>A transação já foi paga ao lojista. Você pode entrar em contato diretamente com o comércio para agendar a entrega do produto ou serviço.</p>',
  'transaction-info.chargeback.body':
      '<p>A ordem apresentou um processo de reclamação junto ao banco, por parte do titular do cartão. Por isso, você deverá validar diretamente com a entidade financeira a devolução do dinheiro.</p>',
  'transaction-info.pending.body':
      '<p>Se você pagou com cartão, estamos realizando validações adicionais para garantir que tudo esteja em ordem. Retornaremos em no máximo 4 horas úteis. Se você usou outro método de pagamento, o processo ainda não foi concluído, por favor, verifique. Se tiver alguma dúvida, visite nosso site e acesse a seção de Suporte.</p>',
  'transaction-info.refund.body':
      '<p>O dinheiro foi reembolsado pelo lojista. Observe que o reembolso pode levar entre 15 e 25 dias úteis, a partir do momento em que o lojista solicitou o reembolso. Se você quiser saber exatamente o status atual do reembolso, você deve validá-lo diretamente com seu banco.</p>',
  'transaction-info.in-dispute.body':
      '<p>A ordem apresentou um processo de reclamação junto ao banco, por parte do titular do cartão. Se você quiser saber exatamente o status atual do processo, você deve validá-lo diretamente com seu banco.</p>',
  'transaction-info.partial-refund.body':
      '<p>A ordem apresenta um reembolso parcial, do valor total da compra, realizado pela loja. Observe que o reembolso pode levar entre 15 e 25 dias úteis a partir do momento em que a loja solicitou o reembolso. Se você quiser saber exatamente o status atual do reembolso, deverá validá-lo diretamente com seu banco.</p>',
  'transaction-info.threeds-rejected.body':
      '<p>Transação recusada. Tente outra forma de pagamento ou verifique com seu banco.</p>',
  'transaction-info.returning.body':
      '<p>A ordem está em processo de reembolso pela rede financeira. Pode levar de 15 a 25 dias úteis para que o dinheiro seja creditado pelo seu banco na sua conta bancária.</p>',
  'transaction-info.not-found.body':
      '<p>Se tiver alguma dúvida, contacte-nos através dos nossos canais de apoio.</p>',


  'status.commercialName': 'Comércio: ',
  'status.orderId': 'Número do ordem: ',
  'status.reference': 'Referência: ',
  'status.paymentMethod': 'Método de pagamento: ',
  'status.status': 'Status: ',

  'status.notFound.title': 'Pagamento não encontrado',
  'status.notFound.message':
      'Não foram encontradas transações com os dados de pesquisa inseridos. Tente novamente com outros dados ou contacte-nos',


  'errorView.title': 'Ocorreu um erro',
  'errorView.message':
    'Lamentamos, mas ocorreu um erro inesperado durante a pesquisa de pagamento. Por favor, tente novamente mais tarde.',


  'formIntroFirstStep.titleLine':
    'Para saber o estado do pagamento, forneça o ID da transação ou os dados relevantes relacionados com este - encontrará transacções dos últimos 3 meses.',
  'formIntroFirstStep.space': ' ',


  'selectCurrency.placeholder': 'Escolher',
  'selectDate.placeholder': 'Escolher',
  'selectPaymentMethod.noOption': 'Método de pagamento inválido',
  'selectCurrency.noOption': 'Moeda inválida',

  'WALLET': 'Carteira',
  'CASH': 'Pagamento em dinheiro',
  'REFERENCED': 'Referência Bancária ',
  'PSE': 'PSE',
  'CARD': 'Cartão',
  'BANK_TRANSFER': 'Transferência bancária',

  'transaction-info.error.header': 'Status',

  'privacy.policy.text': 'Usamos os seus dados pessoais para verificar o status do seu pagamento e fornecer informações sobre a sua transação. Você pode consultar a nossa Política de Privacidade',
  'privacy.policy.link-text': ' aqui.',
  'privacy.policy.link': 'https://brazil.payu.com/politica-de-privacidade-da-payu/',

  'footer.captcha.textStart': 'Este site é protegido por reCAPTCHA e aplicam-se a ',
  'footer.captcha.privacyLink': 'Política de Privacidade',
  'footer.captcha.and': ' e os ',
  'footer.captcha.serviceTermsLink': 'Termos de Serviço',
  'footer.captcha.textEnd': '  do Google.',

};

export default pt;
